import type { DeviceSummary, ProtoJson } from "@fistos/shared/api";
import type { ActionResult, Capabilities } from "@fistos/shared";
import { CircleAlert } from "lucide-solid";
import type { JSX } from "solid-js";
import { toast } from "somoto";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { api, errorText } from "@/lib/api";
import { expectOk, parse } from "@/lib/proto";

export interface PanelProps {
  device: DeviceSummary;
  caps?: Capabilities;
}

/**
 * Runs a direct action and reports failures as toasts. Resolves to the result
 * when the broker let it through and it succeeded, otherwise undefined.
 */
export async function run(deviceId: string, action: ProtoJson, success?: string): Promise<ActionResult | undefined> {
  try {
    const { result } = await api.action(deviceId, action);
    const r = expectOk(parse.result(result));
    if (success) toast.success(success);
    return r;
  } catch (e) {
    toast.error(errorText(e));
    return undefined;
  }
}

export function Unavailable(props: { title: string; children: JSX.Element }) {
  return (
    <Alert>
      <CircleAlert />
      <AlertTitle>{props.title}</AlertTitle>
      <AlertDescription>{props.children}</AlertDescription>
    </Alert>
  );
}

export function OfflineNote(props: { device: DeviceSummary }) {
  return (
    <Unavailable title={`${props.device.name} is offline`}>
      Actions need a live connection. The phone reconnects by itself when it has network access.
    </Unavailable>
  );
}
